// // components/ViewParticipantsResponses/index.tsx
// import React, { useState } from 'react';
// import { Card, CardBody, Col, Input, Label, Row, Table } from 'reactstrap';
// import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader';
// import { ParticipantResponsesTitle } from '../../../Utils/Constants';
// import { useFetchResponsesForAdmin, Phase } from '../../../hooks/participantResponses/useFetchResponsesForAdmin';
// import ParticipantsResponsesBody from './ParticipantsResponsesBody';
// import { Btn } from '../../../AbstractElements';
// import { toast } from 'react-toastify';
// import { exportResponses } from '../../../services/common.service';
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';


// const PHASES: Phase[] = ['all', 'pre', 'during', 'post'];

// export default function ViewParticipantsResponses() {
//   const user = JSON.parse(localStorage.getItem('user') || '{}') as { id?: string; role?: string };
//   const { id: userId } = user ?? {};

//   const {
//     data: reviews,
//     total,
//     loading,
//     error,
//     page,
//     limit,
//     setPage,
//     setLimit,
//     search,
//     setSearch,
//     phase,
//     setPhase,
//     reload
//   } = useFetchResponsesForAdmin({ page: 1, limit: 10, groupId: null, phase: 'all', search: '' });

//   // small handler
//   const onPhaseChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
//     setPhase((ev.target.value as Phase));
//   };

//   const [exportOpen, setExportOpen] = useState(false);
//   const toggleExport = () => setExportOpen(o => !o);


//   return (
//     <Col xxl={12} xl={12} lg={12} md={12} className="box-col-7">
//       <Card>
//         <CommonCardHeader title={ParticipantResponsesTitle} headClass="card-no-border pb-0" />
//         <CardBody className="pt-0">
//           <Row className="gy-2 align-items-center mb-2">
//             <Col md={3}>
//               <Label className="d-flex align-items-center mb-0">Phase:
//                 <Input type="select" value={phase} onChange={onPhaseChange} className="ms-2" style={{ maxWidth: 180 }}>
//                   {PHASES.map(p => <option key={p} value={p}>{p}</option>)}
//                 </Input>
//               </Label>
//             </Col>

//             {/* <Col md={4}>
//               <Label className="d-flex align-items-center mb-0">Group:
//                 <Input
//                   type="select"
//                   value={groupId ?? ''}
//                   onChange={(e) => setGroupId(e.target.value || null)}
//                   className="ms-2"
//                   style={{ maxWidth: 320 }}
//                 >
//                   <option value="">— All groups —</option>
//                   {groupOptions.map(g => <option key={g.id} value={g.id}>{g.title}</option>)}
//                 </Input>
//               </Label>
//             </Col> */}

//             <Col md={3}>
//               <Label className="d-flex align-items-center mb-0">Search:
//                 <Input
//                   type="search"
//                   className="ms-2"
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   placeholder="name or email"
//                   style={{ maxWidth: 320 }}
//                 />
//               </Label>
//             </Col>

//             <Col md={2} className="text-end">
//               {/* <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', alignItems: 'center' }}>
//                 <div className="dropdown">
//                   <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false">
//                     Export
//                   </button>
//                   <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">
//                     <li><button className="dropdown-item" onClick={() => exportResponses('csv', String(userId), phase, search)}>Export CSV</button></li>
//                     <li><button className="dropdown-item" onClick={() => exportResponses('excel', String(userId), phase, search)}>Export Excel</button></li>
//                     <li><button className="dropdown-item" onClick={() => exportResponses('pdf', String(userId), phase, search)}>Export PDF</button></li>
//                   </ul>
//                 </div>

//                 <Btn color="primary" onClick={() => reload()}>Refresh</Btn>
//               </div> */}
//               <Dropdown isOpen={exportOpen} toggle={toggleExport} direction="down">
//                 <DropdownToggle caret color="secondary" className="btn-outline-secondary">
//                   Export
//                 </DropdownToggle>
//                 <DropdownMenu end>
//                   <DropdownItem tag="button" type="button" onClick={() => exportResponses('csv', String(userId), phase, search)}>
//                     Export CSV
//                   </DropdownItem>
//                   <DropdownItem tag="button" type="button" onClick={() => exportResponses('excel', String(userId), phase, search)}>
//                     Export Excel
//                   </DropdownItem>
//                   <DropdownItem tag="button" type="button" onClick={() => exportResponses('pdf', String(userId), phase, search)}>
//                     Export PDF
//                   </DropdownItem>
//                 </DropdownMenu>
//               </Dropdown>
//             </Col>

//             <Col md={2} className="text-end">
//               <Btn color="primary" onClick={() => reload()}>Refresh</Btn>
//             </Col>
//           </Row>

//           <div className="table-responsive theme-scrollbar">
//             <Table className="display table-bordernone dataTable no-footer">
//               <thead>
//                 <tr role="row">
//                   <th>Participant</th>
//                   <th>Group</th>
//                   <th>Assignment</th>
//                   <th>Phase summary</th>
//                   <th>Submitted At</th>
//                   <th className="text-end">View</th>
//                 </tr>
//               </thead>

//               <ParticipantsResponsesBody
//                 reviews={reviews}
//                 loading={loading}
//                 error={error}
//               />
//             </Table>
//           </div>

//           {/* simple pagination */}
//           <div className="d-flex align-items-center justify-content-between mt-3">
//             <div>
//               <small className="text-muted">Total: {total}</small>
//             </div>
//             <div className="d-flex align-items-center gap-2">
//               <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} className="form-select">
//                 {[10, 20, 50, 100].map(n => <option key={n} value={n}>{n} / page</option>)}
//               </select>

//               <div>
//                 <nav aria-label="pagination">
//                   <ul className="pagination mb-0">
//                     <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
//                       <button className="page-link" onClick={() => setPage(Math.max(1, page - 1))}>Prev</button>
//                     </li>
//                     <li className="page-item disabled"><button className="page-link">{page}</button></li>
//                     <li className={`page-item ${page * limit >= total ? 'disabled' : ''}`}>
//                       <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </CardBody>
//       </Card>
//     </Col>
//   );
// }

// src/components/ViewParticipantsResponses/index.tsx
import React, { useMemo, useState } from 'react';
import {
  Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Row, Table
} from 'reactstrap';
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader';
import { ParticipantResponsesTitle } from '../../../Utils/Constants';
import { useFetchResponsesForAdmin, Phase } from '../../../hooks/participantResponses/useFetchResponsesForAdmin';
import ParticipantsResponsesBody from './ParticipantsResponsesBody';
import { Btn } from '../../../AbstractElements';
import { toast } from 'react-toastify';

const PHASES: Phase[] = ['all', 'pre', 'during', 'post'];

export default function ViewParticipantsResponses() {
  const user = JSON.parse(localStorage.getItem('user') || '{}') as { id?: string; role?: string };
  const { id: userId } = user ?? {};

  const {
    data: reviews,
    group,
    total,
    loading,
    error,
    page,
    limit,
    setPage,
    setLimit,
    search,
    setSearch,
    phase,
    setPhase,
    reload
  } = useFetchResponsesForAdmin({ page: 1, limit: 10, groupId: null, phase: 'all', search: '' });

  const [exporting, setExporting] = useState(false);

  const onPhaseChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setPhase((ev.target.value as Phase));
  };

  const [exportOpen, setExportOpen] = useState(false);
  const toggleExport = () => setExportOpen(o => !o);

  // Export function
  async function exportResponses(format: 'csv' | 'excel' | 'pdf') {
    try {
      if (!userId) {
        toast.error('User not logged in');
        return;
      }
      setExporting(true);

      const params: any = {
        userId,
        phase,
        format
      };
      if (group && group._id) params.groupId = group._id;
      if (search) params.search = search;

      const qs = new URLSearchParams();
      Object.keys(params).forEach(k => {
        const v = params[k];
        if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
      });

      // Use REACT_APP_API_BASE if you set it, otherwise assume same origin + /api
      const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
      const url = `${API_BASE}book-review/review-response/group/phase-wise-responses/export?${qs.toString()}`;

      const resp = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: '*/*',
          // add auth header if needed, e.g. Authorization: `Bearer ${token}`
        }
      });

      if (!resp.ok) {
        const json = await resp.json().catch(() => null);
        throw new Error(json?.error || json?.message || `Export failed: ${resp.status}`);
      }

      const blob = await resp.blob();
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      let ext = 'csv';
      if (format === 'excel') ext = 'xlsx';
      if (format === 'pdf') ext = 'pdf';

      const filename = `participants_export_${timestamp}.${ext}`;
      const urlBlob = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(urlBlob);
    } catch (err: any) {
      console.error('Export error', err);
      toast.error(err?.message || 'Export failed');
    } finally {
      setExporting(false);
    }
  }

  return (
    <Col xxl={12} xl={12} lg={12} md={12} className="box-col-7">
      <Card>
        <CommonCardHeader title={ParticipantResponsesTitle} headClass="card-no-border pb-0" />
        <CardBody className="pt-0">
          <Row className="gy-2 align-items-center mb-2">
            <Col md={3}>
              <Label className="d-flex align-items-center mb-0">Phase:
                <Input type="select" value={phase} onChange={onPhaseChange} className="ms-2" style={{ maxWidth: 180 }}>
                  {PHASES.map(p => <option key={p} value={p}>{p}</option>)}
                </Input>
              </Label>
            </Col>

            <Col md={3}>
              <Label className="d-flex align-items-center mb-0">Search:
                <Input
                  type="search"
                  className="ms-2"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="name or email"
                  style={{ maxWidth: 320 }}
                />
              </Label>
            </Col>

            <Col md={2} className="text-end">
              {/* <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', alignItems: 'center' }}>
                <div className="dropdown">
                  <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    {exporting ? 'Exporting...' : 'Export'}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">
                    <li><button type="button" className="dropdown-item" onClick={() => exportResponses('csv')}>Export CSV</button></li>
                    <li><button type="button" className="dropdown-item" onClick={() => exportResponses('excel')}>Export Excel</button></li>
                    <li><button type="button" className="dropdown-item" onClick={() => exportResponses('pdf')}>Export PDF</button></li>
                  </ul>
                </div>

              </div> */}

              <Dropdown isOpen={exportOpen} toggle={toggleExport} direction="down" inNavbar>
                <DropdownToggle caret color="secondary" className="btn-outline-secondary" outline tag="button" type="button" aria-haspopup={true} aria-expanded={exportOpen}>
                  {exporting ? 'Exporting...' : 'Export'}
                </DropdownToggle>

                <DropdownMenu end>
                  <DropdownItem tag="button" type="button" onClick={() => { console.log('Export CSV click'); exportResponses('csv'); }}>
                    Export CSV
                  </DropdownItem>
                  <DropdownItem tag="button" type="button" onClick={() => { console.log('Export Excel click'); exportResponses('excel'); }}>
                    Export Excel
                  </DropdownItem>
                  <DropdownItem tag="button" type="button" onClick={() => { console.log('Export PDF click'); exportResponses('pdf'); }}>
                    Export PDF
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

              {/* <Dropdown isOpen={exportOpen} toggle={toggleExport} direction="down">
                <DropdownToggle caret color="secondary" className="btn-outline-secondary">
                  Export
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem tag="button" type="button" onClick={() => exportResponses('csv', String(userId), phase, search)}>
                    Export CSV
                  </DropdownItem>
                  <DropdownItem tag="button" type="button" onClick={() => exportResponses('excel', String(userId), phase, search)}>
                    Export Excel
                  </DropdownItem>
                  <DropdownItem tag="button" type="button" onClick={() => exportResponses('pdf', String(userId), phase, search)}>
                    Export PDF
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </Col>

            <Col md={2} className="text-end">
              <Btn color="primary" onClick={() => reload()}>Refresh</Btn>

            </Col>

          </Row>

          <div className="table-responsive theme-scrollbar">
            <Table className="display table-bordernone dataTable no-footer">
              <thead>
                <tr role="row">
                  <th>Participant</th>
                  <th>Group</th>
                  <th>Assignment</th>
                  <th>Phase summary</th>
                  <th>Submitted At</th>
                  <th className="text-end">View</th>
                </tr>
              </thead>

              <ParticipantsResponsesBody
                reviews={reviews}
                loading={loading}
                error={error}
              />
            </Table>
          </div>

          <div className="d-flex align-items-center justify-content-between mt-3">
            <div>
              <small className="text-muted">Total: {total}</small>
            </div>
            <div className="d-flex align-items-center gap-2">
              <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} className="form-select">
                {[10, 20, 50, 100].map(n => <option key={n} value={n}>{n} / page</option>)}
              </select>

              <div>
                <nav aria-label="pagination">
                  <ul className="pagination mb-0">
                    <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setPage(Math.max(1, page - 1))}>Prev</button>
                    </li>
                    <li className="page-item disabled"><button className="page-link">{page}</button></li>
                    <li className={`page-item ${page * limit >= total ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}

